export class ExcelDataValidator {
  validationRules = {
    //EStamp Columns
    reference_id: this.validateReferenceId,
    referance_id: this.validateReferanceId,
    branch_code: this.validateBranchCode,
    first_party_name: this.validateFirstPartyName,
    second_party_name: this.validateSecondPartyName.bind(this),
    stamp_duty_paid_by: this.validateStampDutyPaidBy,
    stamp_duty_amount: this.validateStampDutyAmount,
    description: this.validateDescription,
    article_code: this.validateArticleCode,
    consideration_amount: this.validateConsiderationAmount,
    execution_date: this.validateExecutionDate,
    update_by: this.validateUpdateBy,
    //Esign Columns
    // referance_id: this.validateReferenceId,
    sign_name: this.validateSignName,
    sign_email: this.validateEmail,
    sign_contact_number: this.validateContactNumber,
    sign_position: this.validateSignPosition,
    method: this.validateMethod,
    pages: this.validatePages,
    user_type: this.validateUserType,
  };

  date_format = /^([0-2]?[0-9]|(3)[0-1])(\/)(((0)?[0-9])|((1)[0-2]))(\/)\d{4}$/;
  isInventeryData: boolean = false;

  validateExcelData(serviceType, excelData, rowsWithIssues, isInventeryData?: boolean) {
    this.isInventeryData = isInventeryData;
    const columnHeaders = [];

    if (serviceType === 'Both') {
      columnHeaders.push(
        'referance_id',
        'branch_code',
        'first_party_name',
        'second_party_name',
        'stamp_duty_paid_by',
        'stamp_duty_amount',
        'description',
        'article_code',
        'consideration_amount',
        'execution_date',
        'sign_name',
        'sign_email',
        'sign_contact_number',
        'sign_position',
        'method',
        'pages',
        'user_type'
      );
    } else if (serviceType === 'E-Stamp') {
      columnHeaders.push(
        'referance_id',
        'branch_code',
        'first_party_name',
        'second_party_name',
        'stamp_duty_paid_by',
        'stamp_duty_amount',
        'description',
        'article_code',
        'consideration_amount',
        'execution_date',
        'update_by'
      );
    } else if (serviceType === 'E-Sign') {
      columnHeaders.push(
        'referance_id',
        'branch_code',
        'sign_name',
        'sign_email',
        'sign_contact_number',
        'sign_position',
        'method',
        'pages',
        'user_type'
      );
    }

    const errors = [];

    for (let i = 0; i < excelData.length; i++) {
      const rowErrors = {
        rowNumber: i + 2,
        referance_id: excelData[i].referance_id,
        error: '',
      };

      for (const column of columnHeaders) {
        if (column === 'branch_code' || column === 'referance_id') {
          if (
            (excelData[i][column] === null || excelData[i][column] === '') &&
            (excelData[i - 1][column] !== null ||
              excelData[i - 1][column] !== '')
          )
            excelData[i][column] = excelData[i - 1][column];
        }

        const validationFn = this.validationRules[column];
        const error = validationFn(excelData[i][column]);

        if (error) {
          if (!rowErrors[column]) {
            rowErrors[column] = error;
            rowErrors.error += error;
            rowsWithIssues.push(excelData[i]);
          }
        }
      }

      if (Object.keys(rowErrors).length > 0) {
        //rowErrors.rowNumber = rowErrors.rowNumber; // If your Excel data has row numbers, include them here.
        errors.push(rowErrors);
      }
    }

    return errors;
  }

  // Validation functions
  validateReferanceId(value) {
    if (!value) {
      return 'Invalid or missing Referance ID. ';
    }
    // Additional validation logic for referance_id if needed
    return null;
  }

  validateReferenceId(value) {
    if (!value) {
      return 'Invalid or missing Reference ID. ';
    }
    // Additional validation logic for referance_id if needed
    return null;
  }

  validateBranchCode(value) {
    if (!value) {
      return 'Invalid or missing Branch ID. ';
    }
    // Additional validation logic for branch_id if needed
    return null;
  }

  validateFirstPartyName(value) {
    const format = /^[a-zA-Z0-9\s"&,':;()\/-]+$/;
    if (!value || typeof value !== 'string') {
      return 'Invalid or missing First Party Name. ';
    }
    // Additional validation logic for name if needed
    if (value && value.length > 50) {
      return 'First Party Name should not exceed 50 characters. ';
    }
    if (value && !format.test(value)) {
      return `First Party Name contains invalid characters. Only letters, numbers, spaces and " / & , - ' : ( ) ; are allowed. `;
    }
    return null;
  }

  validateSignName(value) {
    const format = /^[a-zA-Z0-9\s]+$/;
    if (!value || typeof value !== 'string') {
      return 'Invalid or missing Sign Name. ';
    }
    // Additional validation logic for name if needed
    if (value && value.length > 50) {
      return 'Sign Name should not exceed 50 characters. ';
    }
    if (value && !format.test(value)) {
      return 'Sign Name should not contain special characters. ';
    }
    return null;
  }

  validateSecondPartyName(value) {
    const format = this.isInventeryData
    ? /^[a-zA-Z0-9 .\/&()"',:;-]+$/
    : /^[a-zA-Z0-9\s.\/&()"',:;-]+$/;

    if (!value || typeof value !== 'string') {
      return 'Invalid or missing Second Party Name. ';
    }
    // Additional validation logic for name if needed
    if (value && value.length > 50 && !this.isInventeryData) {
      return 'Second Party Name should not exceed 50 characters. ';
    }
    if (value && !format.test(value)) {
      return this.isInventeryData
        ? `In Second Party Name only letters, numbers, spaces and . " / & , - ' : ( ) ; are allowed.`
        : `Second Party Name contains invalid characters. Only letters, numbers, spaces and " / & , - ' : ( ) ; are allowed. `;
    }
    return null;
  }


  validateStampDutyPaidBy(value) {
    if (!value || value.length <= 0) {
      return 'Invalid or missing Stamp Duty Paid By.';
    }
    if (value !== 'first_party_name' && value !== 'second_party_name') {
      return 'Stamp duty paid by should be either first_party_name or second_party_name. ';
    }
    // Additional validation logic for stamp_duty_paid_by if needed
    return null;
  }

  validateStampDutyAmount(value) {
    if (!Number.isFinite(value) || value <= 0) {
      return 'Invalid or missing Stamp Duty Amount. ';
    }
    // if (value && value < 10) {
    //   return 'Stamp Duty Amount cannot be less than 10. ';
    // }
    if (value && typeof value !== 'number') {
      return 'Stamp duty amount should be a number. ';
    }
    if (value % 1 !== 0) {
      return 'Stamp duty amount cannot be decimal. ';
    }
    // Additional validation logic for stamp_duty_amount if needed
    return null;
  }

  validateDescription(value) {
    if (!value || typeof value !== 'string') {
      return 'Invalid or missing Description. ';
    }
    if (value !== undefined && value.length > 100) {
      return 'Description should not exceed 100 characters. ';
    }
    // Additional validation logic for description if needed
    return null;
  }

  validateArticleCode(value) {
    if (!value) {
      return 'Invalid or missing Article ID. ';
    }
    // Additional validation logic for article_code if needed
    return null;
  }

  validateConsiderationAmount(value) {
    if (!Number.isFinite(value) || value < 0) {
      return 'Invalid or missing Consideration Amount. ';
    }
    if (value && typeof value !== 'number') {
      return 'Consideration amount should be a number. ';
    }
    // if (value % 1 !== 0) {
    //     return 'Consideration amount cannot be decimal. ';
    // }
    // Additional validation logic for consideration_amount if needed
    return null;
  }

  validateUpdateBy(value) {
    return null;
  }
  validateExecutionDate(value) {
    const currentDate = new Date();
    //  currentDate.setHours(0, 0, 0, 0);

    if (!value) {
      return 'Invalid or missing Execution Date.';
    }

    const dateString = value.toString();

    if (dateString.includes('-')) {
      // For "dd-mm-yyyy" format
      const [day, month, year] = dateString.split('-').map(Number);
      const dateObject = new Date(year, month - 1, day); // Month is zero-based

      if (dateObject > currentDate) {
        return 'Execution Date should  be in Format (DD-MM-YYYY) and not be greater than the current date.';
      }
    } else if (dateString.includes('/')) {
      // For "dd-mm-yyyy" format
      const [day, month, year] = dateString.split('/').map(Number);
      const dateObject = new Date(year, month - 1, day); // Month is zero-based
      if (dateObject > currentDate) {
        return 'Execution Date should  be in Format (DD-MM-YYYY) and not be greater than the current date.';
      }
    } else if (dateString.includes('.')) {
      // For "dd.mm.yyyy" format
      const [day, month, year] = dateString.split('.').map(Number);
      const dateObject = new Date(year, month - 1, day); // Month is zero-based
      if (dateObject > currentDate) {
        return 'Execution Date should be in (dd.mm.yyyy) format and not be greater than the current date.';
      }
    } else {
      // For Excel date format
      value = Math.floor(value);

      const epochDiff = 25569;
      const date = new Date((value - epochDiff) * 24 * 60 * 60 * 1000);

      if (date > currentDate) {
        return 'Execution Date should  be in Format (DD-MM-YYYY) and not be greater than the current date.';
      }
    }

    return null;
  }

  validateEmail(value: string) {
    const emailFormat = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!value || typeof value !== 'string') {
      return 'Invalid or missing Email. ';
    }
    if (!emailFormat.test(value)) {
      return 'Invalid email format. ';
    }
    // Additional validation logic for email if needed
    return null;
  }

  validateContactNumber(value) {
    if (!value) {
      return null;
    }

    if (typeof value === 'string') {
      if (value.length !== 10) {
        return 'Contact number must be exactly 10 characters.';
      }
    } else if (typeof value === 'number') {
      if (value.toString().length !== 10) {
        return 'Contact number must be exactly 10 digits.';
      }
    }
    return null;
  }

  // validateSignPosition(value: string) {
  //     if (!value || typeof value !== "string") {
  //         return "Invalid or missing Sign Position. ";
  //     }
  //     // Additional validation logic for sign_position if needed
  //     return null;
  // }

  validateSignPosition(value: string) {
    const validPositions = [
      'TOP_LEFT',
      'TOP_CENTRE',
      'TOP_CENTER',
      'TOP_RIGHT',
      'MIDDLE_LEFT',
      'MIDDLE_RIGHT',
      'BOTTOM_LEFT',
      'BOTTOM_CENTRE',
      'BOTTOM_CENTER',
      'BOTTOM_RIGHT',
      'BOTTOM_LEFT_MIDDLE',
      'BOTTOM_RIGHT_MIDDLE',
      'BAILEE_1',
      'CHCOMPANY',
      'PNEUMATIC',
      'ATLAS_1_ABOVE',
      'ATLAS_1_BELOW',
      'ATLAS_2_ABOVE',
      'ATLAS_2_BELOW',
      'ATLAS_3',
    ];

    if (!value || typeof value !== 'string') {
      return 'Invalid or missing Sign Position.';
    }

    if (!validPositions.includes(value)) {
      return `Invalid Sign Position. Must be in ALL CAPS . Example:- TOP_LEFT , MIDDLE_LEFT , BOTTOM_LEFT`;
    }

    // If value is valid, return null (no error)
    return null;
  }

  validateMethod(value: string) {
    if (!value || typeof value !== 'string') {
      return 'Invalid or missing Method. ';
    }
    // Additional validation logic for method if needed
    return null;
  }

  validatePages(value: string | number): string | null {
    if (!value || (typeof value !== 'string' && typeof value !== 'number')) {
      return 'Invalid or missing Pages.';
    }

    return null;
  }
  validateUserType(value: string) {
    if (!value || typeof value !== 'string') {
      return 'Invalid or missing User Type. ';
    }
    // Additional validation logic for user_type if needed
    return null;
  }

  // ... other validation methods ...
}
